import firebase from "firebase/compat/app";

import "firebase/compat/auth";

import {
  isSignInWithEmailLink,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signInWithEmailLink,
  signOut,
  User,
} from "firebase/auth";

import { getApp } from "firebase/app";
import { getMessaging, getToken as getFcmToken } from "firebase/messaging";

import "firebase/compat/firestore";

import { CURRENT_URL } from "@/constants/core";
import { isProd } from "@/constants/env";
import { logError } from "@/utils/errors";

const configDev = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY_DEV,
  authDomain: "seeri-dev.firebaseapp.com",
  projectId: "seeri-dev",
  storageBucket: "seeri-dev.appspot.com",
  messagingSenderId: "425297633803",
  appId: "1:425297633803:web:092af3b14f792b79d65d0e",
  measurementId: "G-84RY012EQS",
  vapidKey: "BM-WZ1qRfJ73Ja_VoIRyEaRTnjoXUoUNxffklYoC2kWcB7LJJYpxo8EDOWm0rUPDZZ71Ha9G3_GmrCw9JzOxmFM",
};

const configProd = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY_PROD,
  authDomain: "seeri-b81c0.firebaseapp.com",
  projectId: "seeri-b81c0",
  storageBucket: "seeri-b81c0.appspot.com",
  messagingSenderId: "292039451305",
  appId: "1:292039451305:web:315c1adec303eecbbdffb8",
  measurementId: "G-0SQXH7077N",
  vapidKey: "BH_DBn-Zf_50y9tJltFGzNo52gCI1R5Y6MAkiRXcTSlskDsHJDIE0wKvN73zCegfaaTtF_qxF5aIBmZycsGfEKE",
};
const firebaseConfig = isProd ? configProd : configDev;

export const app = firebase.initializeApp(firebaseConfig, "primary");
export const auth = firebase.auth(app);
export const db = app.firestore();

export const getCurrentUser = async (): Promise<User | null> => {
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });
};

export const getToken = async () => {
  const user = await getCurrentUser();
  return user?.getIdToken();
};

export const firebaseLogin = async (email: string, password: string) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const firebaseLogout = () => {
  return signOut(auth);
};

export const firebaseConfirmSigninLink = async () => {
  return isSignInWithEmailLink(auth, window.location.href);
};

export const firebaseSigninEmailLink = async (email: string) => {
  return signInWithEmailLink(auth, email, window.location.href);
};

export const requestFcmToken = async (): Promise<string | null> => {
  try {
    if (!("Notification" in window) || !("serviceWorker" in navigator)) return null;
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    // Pass the Firebase config to the messaging service worker via query
    // params: the SW is a static file in public/ and can't read build-time env,
    // so this keeps the (restricted) keys out of the SW source.
    const swParams = new URLSearchParams({
      apiKey: firebaseConfig.apiKey,
      authDomain: firebaseConfig.authDomain,
      projectId: firebaseConfig.projectId,
      storageBucket: firebaseConfig.storageBucket,
      messagingSenderId: firebaseConfig.messagingSenderId,
      appId: firebaseConfig.appId,
    });
    const registration = await navigator.serviceWorker.register(
      `/firebase-messaging-sw.js?${swParams.toString()}`,
    );
    await navigator.serviceWorker.ready;

    const messaging = getMessaging(getApp("primary"));
    const token = await getFcmToken(messaging, {
      vapidKey: firebaseConfig.vapidKey,
      serviceWorkerRegistration: registration,
    });
    return token || null;
  } catch (error) {
    logError(error);
    return null;
  }
};
